module.exports = __webpack_public_path__ + "static/img/3.59a5f7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/3.jpg
// module id = U+9m
// module chunks = 1